import {AnswerRequestInterface, AnswerRequestMock, QuestionAnswerInterface } from 'ApiGen/CustomerVerificationV2';

export class AnswerRequest implements AnswerRequestInterface{ 
    idNumber: string = "";
    answers?: Array<QuestionAnswerInterface>;
    mock?: AnswerRequestMock;
}
